export default __webpack_public_path__ + "static/media/orientation_all.96b7ac66.pdf";